import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { forwardRef, useEffect } from 'react';

import Box from 'shopper/components/Box';
import Heading from 'shopper/components/Heading';
import Link from 'shopper/components/Link';
import Text from 'shopper/components/Text';

import { sendEvent } from 'lib/gtag';

import { useModal } from 'providers/ModalProvider';

import WishlistSuggestionsKeywords from './WishlistSuggestionsKeywords';

import WISHLIST from 'constants/wishlist';

const WishlistModal = dynamic(() => import('./WishlistModal'), { ssr: false });

const WishlistSuggestions = forwardRef(
  (
    {
      gaEventCategory,
      keywordsDisplay,
      headingProps,
      keywordButtonType,
      keywordButtonTypeCanChange,
      withEditWishlist,
      ...rest
    },
    ref
  ) => {
    const { showModal } = useModal();

    useEffect(() => {
      sendEvent({ gaEventCategory, action: 'appear' });
    }, []);

    const onEditWishlistClick = () =>
      showModal(WishlistModal, { isOpen: true });

    return (
      <Box
        flexDirection="column"
        flexWrap="wrap"
        overflow="hidden"
        mb={4}
        py={4}
        px={[4, null, 6]}
        ref={ref}
        full
        {...rest}
      >
        <Heading
          mb={[2, null, 4]}
          {...headingProps}
        >{`${WISHLIST.TITLE}:`}</Heading>
        <Text maxWidth="100%" mb={[6, null, 4]}>
          {WISHLIST.HOW_IT_WORKS}
        </Text>
        {withEditWishlist && (
          <Link
            display={['none', null, 'inset']}
            data-test-selector="open-edit-wishlist"
            mb={4}
            onClick={onEditWishlistClick}
          >
            Editar minha lista
          </Link>
        )}
        <WishlistSuggestionsKeywords
          gaEventCategory={gaEventCategory}
          keywordsDisplay={keywordsDisplay}
          keywordButtonType={keywordButtonType}
          keywordButtonTypeCanChange={keywordButtonTypeCanChange}
        />
      </Box>
    );
  }
);

WishlistSuggestions.displayName = 'WishlistSuggestions';

WishlistSuggestions.defaultProps = {
  headingProps: {
    size: 'size5',
    as: 'span',
  },
  keywordButtonType: null,
  keywordButtonTypeCanChange: false,
  keywordsDisplay: [],
  withEditWishlist: false,
};

WishlistSuggestions.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  headingProps: PropTypes.shape(),
  keywordButtonType: PropTypes.string,
  keywordButtonTypeCanChange: PropTypes.bool,
  keywordsDisplay: PropTypes.arrayOf(PropTypes.string),
  withEditWishlist: PropTypes.bool,
};

export default WishlistSuggestions;
